import { render, staticRenderFns } from "./textElement.vue?vue&type=template&id=4fe09690&scoped=true"
import script from "./textElement.vue?vue&type=script&lang=js"
export * from "./textElement.vue?vue&type=script&lang=js"
import style0 from "./textElement.vue?vue&type=style&index=0&id=4fe09690&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe09690",
  null
  
)

export default component.exports